import { z } from "zod";
// User Role Types
export const UserRoleSchema = z.enum(["admin", "member"]);
// Onboarding Flow Types
export const OnboardingFlowSchema = z.enum(["org", "team"]);
// Call Provider Types
export const CallProviderSchema = z.enum([
    "zoom",
    "teams",
    "google-meet",
    "other",
]);
